import fr_FR from './fr_FR.json';
import en_GB from './en_GB.json';

const messages = {
  'fr-FR': fr_FR,
  'en-GB': en_GB,
};

export default messages;
